import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Box,
  Container,
  Card,
  CardContent,
  CircularProgress,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Typography,
} from "@mui/material";
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from "@mui/icons-material";

import {
  primary,
  secondary,
  darkBg,
  textPrimary,
  textsecondary,
  lightBg2,
} from "../../constants/colors";
import background from "../../assets/background.svg";
import Logo from "../../assets/home_logo_1.svg";

// APIs
import { resetPassowrd } from "../../helpers/Authentication";
import Toast from "../../components/toast";
import { passwordRegex } from "../../constants/regex";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleChangePassowrd = async () => {
    try {
      if (!passwordRegex.test(password)) {
        Toast.error(
          "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.",
        );
        return;
      }
      setIsLoading(true);
      const paramValue = queryParams.get("token");
      const response = await resetPassowrd({
        resetToken: paramValue,
        password: password,
      });
      if (response.isSuccess === true && response.statusCode === 200) {
        Toast.success(response.message);
        navigate("/login");
      } else {
        Toast.error(response.message);
      }
      setIsLoading(false);
    } catch (error) {
      Toast.error(error.message);
      setIsLoading(false);
    }
  };

  return (
    // <Box
    //   style={{
    //     minHeight: "100vh",
    //     backgroundColor: "#000000",
    //     backgroundImage: `url(${background})`,
    //     backgroundSize: "cover",
    //     backgroundPosition: "center",
    //     backgroundRepeat: "no-repeat",
    //     display: "flex",
    //     alignItems: "center",
    //     justifyContent: "center",
    //     // padding: { xs: 2, sm: 4 }
    //   }}
    // >
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        maxHeight: "100vh",
        width: "100%",
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: "15px",
          top: "15px",
        }}
      >
        <img src={Logo} width={"100px"} height={"100px"} />
      </div>
      <Container>
        <Box textAlign="center">
          <div
            style={{
              background: "transparent",
              boxShadow: "none",
            }}
          >
            <Box
              sx={{
                background: "transparent",
                // minHeight: isSmallMobile ? '100vh' : 'auto',
                minHeight: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: { xs: 2, sm: 4 },
              }}
            >
              <Card
                sx={{
                  width: "100%",
                  maxWidth: 400,
                  backgroundColor: lightBg2,
                  borderRadius: { xs: "20px", sm: "20px" },
                  boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
                }}
              >
                <CardContent sx={{ p: { xs: 3, sm: 3 } }}>
                  <Box
                    component="form"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                    }}
                  >
                    <TextField
                      fullWidth
                      label="Password"
                      type={showPassword ? "text" : "password"}
                      size="medium"
                      placeholder="Enter your new password"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                              sx={{ color: "#666" }}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOffIcon />
                              ) : (
                                <VisibilityIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />

                    <Button
                      fullWidth
                      variant="contained"
                      size="large"
                      onClick={handleChangePassowrd}
                      sx={{
                        backgroundColor: "#6366f1",
                        borderRadius: "8px",
                        padding: "14px",
                        fontSize: "1rem",
                        fontWeight: 600,
                        textTransform: "none",
                        mt: 1,
                        "&:hover": { backgroundColor: "#5855eb" },
                      }}
                    >
                      {isLoading === true ? (
                        <CircularProgress color="#5855eb" size={"24px"} />
                      ) : (
                        "Reset Password"
                      )}
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Box>
            <Typography
              variant="body2"
              sx={{ color: "#ccc", textAlign: "center", mt: 1 }}
            >
              Back to{" "}
              <Button
                variant="text"
                onClick={() => navigate("/login")}
                sx={{
                  color: "#6366f1",
                  textDecoration: "underline",
                  textTransform: "none",
                  p: 0,
                  minWidth: "auto",
                  "&:hover": { backgroundColor: "transparent" },
                }}
              >
                login
              </Button>
            </Typography>
          </div>
        </Box>
      </Container>
    </Box>
  );
};

export default ResetPassword;
